import { Component, OnDestroy, Inject } from '@angular/core';
import { Validators, FormControl, AbstractControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, flatMap, map } from 'rxjs/operators';
import { StreamService } from '../services/stream.service';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
@Component({
    styles: [`
        h5.snowflake-header {
            margin-top: 5px; 
            max-width: 270px; 
            text-align: center; 
            margin-bottom: 30px;
        }

        .help {
            cursor: pointer;
            text-decoration: underline;
            /* color: #B2B2B3; */
        }
    `],
    template: `
        <div mat-dialog-title style="margin-bottom: 0px; text-align: center;">Copy Item to Another Topic</div>
        <div mat-dialog-content style="min-width: 450px;">
            <div fxLayoutAlign="center center">
            <h5 class="snowflake-header">
                Note: the item will be displayed if the filter criteria is met. 
                <a class="help" (click)="openHelp()">See how.</a>
            </h5>
            </div>
            <div>
                <mat-form-field fxFlex>
                    <input matInput 
                        [formControl]="topicCtrl" 
                        [matAutocomplete]="auto" 
                        placeholder="Select the Topic to copy into">
                    <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption [displayWith]="topicDisplay">
                        <mat-option *ngFor="let topic of filteredTopics | async" [value]="topic">
                            {{topic.title}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="topicCtrl.hasError('required')">required</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div mat-dialog-actions>
            <button mat-button color="primary" [disabled]="topicCtrl.invalid" (click)="copy()">Copy</button>
            <button mat-button mat-dialog-close>Cancel</button>
        </div>
    `})
export class CopyItemDialogComponent implements OnDestroy {
    cleanupTime = new Subject<void>();
    topicCtrl: FormControl;
    filteredTopics = new Subject<any[]>();

    constructor(@Inject(MAT_DIALOG_DATA) private itemId: string,
                private dialogRef: MatDialogRef<CopyItemDialogComponent>, 
                private router: Router, 
                streamService: StreamService) {
        this.topicCtrl = new FormControl('', [Validators.required, this.isTopicValidator]);
        this.topicCtrl.valueChanges
        .pipe(
            debounceTime(500),
            flatMap(term => streamService.tenantStreamSearch({ term, published: true, includeCatalogs: false, type: 'COLLECTION' })),
            map(res => res.content)
        )
        .subscribe(topics => this.filteredTopics.next(topics))
    }

    isTopicValidator(control: AbstractControl): {[key: string]: any} | null {
          return control.value && typeof control.value === 'string' ? { required: true } : null; 
    }

    topicDisplay(topic): string {
        return topic && topic.title ? topic.title : '';
    }

    copy(): void {
        this.dialogRef.close(this.topicCtrl.value.id);
    }

    openHelp(): void {
        (window as any).supportHeroWidget.show({article: '110268-can-i-copy-an-item-from-one-topic-to-another?'});
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}